var Currencies = {
    AUD: 'AUD',
    CAD: 'CAD',
    GBP: 'GBP',
    NZD: 'NZD',
    USD: 'USD',
    EUR: 'EUR',
};

export { Currencies };
